import { makeStyles } from '@material-ui/core/styles';

const multipleButtonStyle = makeStyles(theme => ({
  root: {
    width: '340px',
    height: '50px',
    borderRadius: '12px',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: '340px',
      height: '52px',
    }
  },
  item: {
    overflow: 'hidden',
    cursor: 'pointer',
    background: '#27272A',
    '& a': {
      height: '100%',
      width: '100%',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      // '& [class*="selected"]': {
      //   color: theme.palette.primary.black
      // },
      '& > img': {
        width: '20px',
        height: '20px',
        objectFit: 'contain',
        marginRight: '12px'
      }
    }
  },
  gridContainer: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: 'inherit'
  },
  selected: {
    backgroundColor: '#403DE3'
  },
  btnText: {
    fontWeight: 800,
    fontSize: '15px',
  },
}));

export default multipleButtonStyle;
